
angular.module('dybReports', ['classy', 'dybCharts', 'classy-on',
                              'dyb.programs', 'dyb.util', 'dybTags',
                              'dybReportsAffnet', 'dybReportsAmc',
                              'dybReportActivity', 'dybReportExport']);
